import {Component, Input} from '@angular/core';
import {TaskActionsEnum} from '../../../../../Shared/Enum/task-actions.enum';

@Component({
  selector: 'app-task-action',
  templateUrl: './task-action.component.html',
  styleUrls: ['./task-action.component.scss'],
  standalone: false
})
export class TaskActionComponent {
  @Input() subtype!: number;

  @Input() local?: string;
  @Input() location?: string;
  @Input() shift?: string;

  /**
   * Obtener el mensaje de la acción
   *
   */
  get actionMessage(): string {
    switch (this.subtype) {
      case TaskActionsEnum.inventory:
        return 'Realizar inventario en la ubicacion <strong>' + this.location + '</strong> del local <strong>' + this.local + '</strong>';

      case TaskActionsEnum.inspection:
        return 'Realizar revisión de mise en place en la ubicacion <strong>' + this.location + '</strong> del local <strong>' + this.local + '</strong>';

      case TaskActionsEnum.refill:
        return 'Realizar recarga en la ubicacion <strong>' + this.location + '</strong> del local <strong>' + this.local + '</strong>';

      case TaskActionsEnum.cashClosing:
        return 'Realizar cierre de caja de <strong>' + this.local + '</strong> para el turno <strong>' + this.shift + '</strong>';

      default:
        return '';
    }
  }

}
